<template>
  <div>
    <b-row class="justify-content-md-center text-center pt-5 pb-5">
      <b-col col md="10">
        <preloader></preloader>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Preloader from '@/app/global/components/Preloader'

export default {
  props: {
    code: null
  },
  components: {
    Preloader
  },
  methods: {
    ...mapActions({
      socialSignInToken: 'auth/socialSignInToken'
    })
  },
  mounted () {
    let lang = this.$i18n.i18next.language

    let redirect = '/'
    if ('redirect' in this.$route.query) {
      if (this.$route.query.redirect !== '' && !_.isUndefined(this.$route.query.redirect)) {
        redirect = this.$route.query.redirect
      }
    }

    if ('oauth2' in this.$route.query) {
      if (this.$route.query.oauth2 === 'true') {
        if ('token' in this.$route.query) {

          let token = this.$route.query.token
          let parent = this
          let payload = {
            token: token,
            redirect: redirect,
            lang: lang
          }
          setTimeout(function () {
            parent.socialSignInToken({ payload: payload, context: this })
          }, 1000)
        } else {
          this.$router.push({name: `Home.${this.$i18n.i18next.language}`, params: { error: 2007 }})
        }
      } else {
        if (!_.isNil(this.$route.query.error)) {
          let error = this.$route.query.error
          this.$router.push({name: `Home.${this.$i18n.i18next.language}`, params: { error: error }})
        } else {
          this.$router.push({name: `Home.${this.$i18n.i18next.language}`, params: { error: 2006 }})
        }
      }
    } else if ('registered' in this.$route.query) {
      if (this.$route.query.registered === 'false') {

        let provider = ''
        if ('provider' in this.$route.query) {
          if (this.$route.query.provider === '1' || this.$route.query.provider === '2') {
            provider = this.$route.query.provider
          }
        }
        let url = `${redirect}?registered=false&provider=${provider}&lang=${lang}`
        window.location = url
      }
    } else {
      this.$router.push({name: `Home.${this.$i18n.i18next.language}`, params: { registered: false }})
    }
  }
}
</script>
